import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Form, Field, FormSpy } from 'react-final-form';
import api from 'lib/api';
import { debounce } from 'helpers/content';
import { getTenantSubjects, searchSubjects, createSubject } from 'actions/subjects';
import { addCourse, updateCourse, getCourseByCourseCode, getCourses } from 'actions/courses';
import { getSectionByGraphId } from 'actions/sections';
import { ASSESSMENT_MATRIX } from 'constants/matrixTypes';
import { getRootUrl } from 'helpers/url';
import CustomCoreContent from 'containers/CoreContent/Custom';
import MatrixForm from 'containers/Matrix/Form/MatrixForm';
import Select from 'react-select/async';
import { Expandable, Spinner } from 'UI';
import { Editor } from 'UI/Inputs';
import { Icon, Button } from '@haldor/ui';
var lastValue = '';

var asyncValidate = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(courseCode, initialValues, meta) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve) {
              if (courseCode != null && courseCode != '' && lastValue != courseCode) {
                api.get("courses/coursecode/".concat(courseCode)).then(function (payload) {
                  lastValue = courseCode;

                  if (payload.data != null) {
                    if (initialValues == null || initialValues.id != payload.data.id) {
                      resolve('a-course-with-that-coursecode-already-exists');
                      return true;
                    }
                  }

                  resolve(undefined);
                });
              } else {
                // Dont change field validation if nothing has changed
                resolve(meta.error);
              }
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function asyncValidate(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * @param {object} values
 * @param {function} translate
 * @returns {object} errors
 */


var _validate = function validate(values, translate) {
  var errors = {};

  if (values.title == null || values.title == '') {
    errors.title = 'field-needs-input';
  }

  if (values.courseCode == null || values.courseCode == '') {
    errors.courseCode = 'field-needs-input';
  }

  var purposeText = '';

  if (typeof values.purpose == 'string') {
    purposeText = values.purpose.replace(/<(?:.|\n)*?>/gm, '');
  }

  if (purposeText == '' || purposeText == null) {
    errors.purpose = translate('field-needs-input');
  }

  return errors;
};

var CourseForm = /*#__PURE__*/function (_Component) {
  _inherits(CourseForm, _Component);

  var _super = _createSuper(CourseForm);

  function CourseForm(props) {
    var _this;

    _classCallCheck(this, CourseForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "formRef", /*#__PURE__*/React.createRef());

    _defineProperty(_assertThisInitialized(_this), "submit", function (values) {
      return new Promise( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resolve) {
          var coreContent, _this$props, currentUser, initialValues, translate, detail, matrix, gotError;

          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  coreContent = _this.state.coreContent;
                  _this$props = _this.props, currentUser = _this$props.currentUser, initialValues = _this$props.initialValues, translate = _this$props.translate;
                  values.typeOfSchooling = currentUser.schools.getActiveSchool(currentUser.userId).type;
                  detail = {};
                  detail.purpose = values.purpose;
                  detail.matrix = _this.state.matrix;
                  detail.coreContent = coreContent;

                  if ((values === null || values === void 0 ? void 0 : values.details) != null && (values === null || values === void 0 ? void 0 : values.details.length) > 0) {
                    detail.id = values.details[0].id;
                  }

                  if (detail.matrix != null && detail.matrix._ParagraphSet != null) {
                    detail.matrix._ParagraphSet.forEach(function (paragraph) {
                      paragraph.rows.forEach(function (row) {
                        if (row.id != null && row.id.length != 36) {
                          row.id = null;
                        }

                        row.cells = row.cells.filter(function (step) {
                          return step.gradeF == null;
                        });
                        row.cells.forEach(function (cell) {
                          if (cell.id != null && cell.id.length != 36) {
                            cell.id = null;
                          }
                        });
                      });

                      if (paragraph.id != null && paragraph.id.length != 36) {
                        paragraph.id = null;
                      }
                    });

                    detail.matrix.paragraphSet = JSON.stringify(detail.matrix._ParagraphSet);
                    matrix = {
                      Title: detail.matrix.title,
                      DisableNotAchieved: detail.matrix.disableNotAchieved,
                      Type: detail.matrix.type,
                      ParagraphSet: detail.matrix.paragraphSet
                    };

                    if (values.details != null && values.details.length > 0) {
                      detail.matrixId = values.details[0].matrixID;
                      matrix.id = values.details[0].matrixID;
                    }

                    if (detail.matrixId == null) {
                      detail.matrixId = 0;
                    }

                    if (matrix.id == null) {
                      matrix.id = 0;
                    }

                    detail.matrix = matrix;
                  }

                  values.details = [detail];
                  gotError = false;

                  if (!(_this.state.subjectId == 'new')) {
                    _context2.next = 17;
                    break;
                  }

                  _context2.next = 14;
                  return _this.props.createSubject({
                    title: _this.state.subjectTitle,
                    subjectCode: _this.state.subjectCode,
                    typeOfSchooling: _this.state.subjectSchoolType,
                    shortSubjectCode: _this.state.subjectCode
                  })["catch"](function (error) {
                    gotError = true;

                    _this.setState({
                      subjectError: translate('A subject with that subject code already exists on your tenant')
                    });
                  });

                case 14:
                  if (_this.props.createdSubject != null) {
                    values.subjectId = _this.props.createdSubject.id;
                  }

                  _context2.next = 18;
                  break;

                case 17:
                  values.subjectId = _this.state.subjectId;

                case 18:
                  if (!gotError) {
                    _context2.next = 21;
                    break;
                  }

                  resolve(0);
                  return _context2.abrupt("return", false);

                case 21:
                  if (_this.props.editView == false) {
                    _this.props.addCourse(values, function (response) {
                      // If a group Id is sent to this component, add the curriculum to the group
                      if (_this.props.group != null) {
                        var group = _this.props.group;
                        group.courses.push({
                          id: response.data
                        }); // Put is here since no action for this exists and I did not create one now either. Should be done!

                        api.put('sections', group).then(function () {
                          // Get data again to get fresh data in store
                          if (_this.props.group.graphId != null) {
                            _this.props.getSectionByGraphId(_this.props.group.graphId, 'GRAPH_OBJECT;');
                          }

                          resolve(response.data);
                        });
                      }

                      resolve(response.data);

                      _this.props.onClose(true, true);
                    });
                  } else {
                    values.id = initialValues.id;

                    _this.props.updateCourse(values, function (data) {
                      // Get data again to get fresh data in store
                      if (_this.props.group != null && _this.props.group.graphId != null) {
                        _this.props.getSectionByGraphId(_this.props.group.graphId, 'GRAPH_OBJECT;');
                      }

                      resolve(data);

                      _this.props.onClose(true, true);
                    });
                  }

                case 22:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x4) {
          return _ref2.apply(this, arguments);
        };
      }());
    });

    _defineProperty(_assertThisInitialized(_this), "onSubjectSearch", function (title, callback) {
      if (title != '') {
        var searchValue = title.trim();
        searchValue = searchValue.replace(/[^A-Za-z0-9åäöÅÄÖ ]/g, '');
        searchValue = encodeURIComponent(searchValue);

        if (searchValue != null && searchValue != '') {
          if (searchValue.length < 3) {
            callback([]);
            return false;
          }

          _this.props.searchSubjects(searchValue).then(function () {
            var options = [];

            if (_this.props.subjectsSearchResults != null) {
              _this.props.subjectsSearchResults.forEach(function (subject) {
                options.push({
                  label: subject.title + " - ".concat(subject.subjectCode, " (").concat(_this.props.translate(subject.typeOfSchooling), ")"),
                  value: subject.id
                });
              });
            }

            callback(options);
          });

          return true;
        } else {
          callback([]);
        }
      }

      callback([]);
    });

    _defineProperty(_assertThisInitialized(_this), "onSubjectChange", function (option) {
      if (option.value == 'new') {
        _this.setState({
          subjectId: option.value,
          selectedSubject: option,
          subjectTitle: '',
          subjectCode: '',
          subjectSchoolType: 'PRESCHOOL',
          open: true
        });
      } else {
        var subjects = [];

        if (_this.props.subjectsSearchResults != null) {
          subjects.push.apply(subjects, _toConsumableArray(_this.props.subjectsSearchResults));
        }

        if (_this.props.tenantSubjects != null) {
          subjects.push.apply(subjects, _toConsumableArray(_this.props.tenantSubjects));
        }

        var subject = subjects.find(function (subject) {
          return subject.id == option.value;
        });

        if (subject != null) {
          _this.setState({
            subjectId: option.value,
            subjectTitle: subject.title + " - ".concat(subject.subjectCode, " (").concat(_this.props.translate(subject.typeOfSchooling), ")"),
            subjectCode: subject.subjectCode,
            subjectSchoolType: subject.typeOfSchooling,
            selectedSubject: option
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onMatrixFormUpdate", function (form) {
      var matrix = Object.assign({}, form);

      _this.setState({
        matrix: matrix
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onCoreContentChange", function (content) {
      _this.setState({
        coreContent: content
      });
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var matrix;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this.props.getCourses('CUSTOM_COURSE');

            case 2:
              if (_this.props.initialValues !== null && _this.props.initialValues.details != null) {
                if (_this.props.initialValues.details[0].matrix != null) {
                  matrix = JSON.parse(JSON.stringify(_this.props.initialValues.details[0].matrix));

                  _this.setState({
                    matrix: matrix
                  });
                }
              }

              _this.props.getTenantSubjects(_this.props.tenant.tenantId);

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));

    _defineProperty(_assertThisInitialized(_this), "renderCoreContent", function () {
      var coreContent = _this.state.coreContent;
      return /*#__PURE__*/React.createElement(Expandable, {
        title: _this.props.translate('Subject content')
      }, /*#__PURE__*/React.createElement(CustomCoreContent, {
        coreContents: coreContent,
        onChange: _this.onCoreContentChange
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderInput", function (_ref4) {
      var input = _ref4.input,
          label = _ref4.label,
          type = _ref4.type,
          placeholder = _ref4.placeholder,
          maxlength = _ref4.maxlength,
          _ref4$meta = _ref4.meta,
          touched = _ref4$meta.touched,
          error = _ref4$meta.error,
          warning = _ref4$meta.warning,
          validating = _ref4$meta.validating,
          pristine = _ref4$meta.pristine;
      return /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative'
        }
      }, /*#__PURE__*/React.createElement("input", _extends({
        placeholder: placeholder || label,
        type: type,
        style: touched && error ? {
          border: '1px solid red'
        } : {},
        maxLength: maxlength
      }, input)), pristine && validating ? /*#__PURE__*/React.createElement("div", {
        className: "async-validating"
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true,
        small: true
      })) : null, touched && (error && /*#__PURE__*/React.createElement("span", {
        style: {
          marginTop: '1rem',
          color: 'red'
        }
      }, _this.props.translate(error)) || warning && /*#__PURE__*/React.createElement("span", {
        style: {
          marginTop: '1rem',
          color: 'red'
        }
      }, _this.props.translate(warning))));
    });

    _this.schoolTypes = ['ADULT_EDUCATION', 'BASIC_ADULT_EDUCATION', 'COMPULSORY_SCHOOL', 'EDU_FOR_ADULTS_WITH_LEARNING_DISABILITIES', 'EDU_FOR_PUPILS_WITH_LEARNING_DISABILITIES', 'PRESCHOOL', 'SAMI_SCHOOL', 'SPECIAL_SCHOOL_FOR_PUPILS_WITH_IMPAIRED_HEARING', 'SWEDISH_FOR_IMMIGRANTS', 'UPPER_SECONDARY_EDUCATION', 'VOCATIONAL_EDUCATION'];
    var _coreContent = null;
    var _matrix = null;
    var selectedSubject = null;
    var subjectTitle = null;
    var subjectId = null;

    if (props.initialValues != null && props.initialValues.details != null) {
      var _props$initialValues$;

      if (props.initialValues.details.length > 0) {
        _coreContent = props.initialValues.details[0].coreContent;
      }

      if (((_props$initialValues$ = props.initialValues.details[0]) === null || _props$initialValues$ === void 0 ? void 0 : _props$initialValues$.matrix) != null) {
        _matrix = props.initialValues.details[0].matrix;
      }

      selectedSubject = {
        value: props.initialValues.subjectId,
        label: props.initialValues.subjectTitle
      };
      subjectTitle = props.initialValues.subjectTitle;
      subjectId = props.initialValues.subjectId;
    }

    _this.state = {
      courseCode: '',
      matrix: _matrix,
      coreContent: _coreContent,
      selectedSubject: selectedSubject,
      subjectTitle: subjectTitle,
      subjectCode: '',
      subjectSchoolType: _this.schoolTypes[0],
      subjectId: subjectId,
      subjectError: null,
      open: false
    };

    _this.onMatrixFormUpdate.bind(_assertThisInitialized(_this));

    return _this;
  }

  _createClass(CourseForm, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // Check if initialValues has changed
      if (this.props.initialValues !== prevProps.initialValues) {
        // If it has, reinitialize the form
        this.formRef.current.initialize(this.props.initialValues);
      }
    } // Store a reference to the form

  }, {
    key: "render",
    value: function render() {
      var _initialValues$detail,
          _this2 = this;

      var _this$props2 = this.props,
          initialValues = _this$props2.initialValues,
          translate = _this$props2.translate;
      var purpose = '';

      if (initialValues != null && ((_initialValues$detail = initialValues.details) === null || _initialValues$detail === void 0 ? void 0 : _initialValues$detail.length) > 0) {
        purpose = initialValues != null ? initialValues.details[0].purpose : '';
      }

      var subjectValid = this.state.selectedSubject != null;

      if (this.state.subjectId == 'new') {
        if (this.state.subjectCode == '' || this.state.subjectTitle == '') {
          subjectValid = false;
        }
      }

      var options = [];

      if (initialValues != null && initialValues.id === 0) {
        options.push({
          label: this.props.translate('+ Create subject'),
          value: 'new'
        });
      }

      if (this.props.tenantSubjects != null) {
        this.props.tenantSubjects.forEach(function (subject) {
          options.push({
            label: subject.title + " - ".concat(subject.subjectCode, " (").concat(_this2.props.translate(subject.typeOfSchooling), ")"),
            value: subject.id
          });
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "form-container course-form"
      }, /*#__PURE__*/React.createElement(Form, {
        initialValues: initialValues,
        initialValuesEqual: function initialValuesEqual() {
          return true;
        },
        keepDirtyOnReinitialize: false,
        onSubmit: this.submit,
        validate: function validate(values) {
          return _validate(values, _this2.props.translate);
        },
        render: function render(_ref5) {
          var handleSubmit = _ref5.handleSubmit,
              submitting = _ref5.submitting,
              valid = _ref5.valid,
              form = _ref5.form;
          // Set the form reference
          _this2.formRef.current = form;
          return /*#__PURE__*/React.createElement("form", {
            onSubmit: handleSubmit,
            className: "form form-component"
          }, /*#__PURE__*/React.createElement(FormSpy, {
            subscription: {
              initialValues: true
            },
            onChange: function onChange(state) {
              console.log("state", state);
              console.log("ll", initialValues);

              if (state.initialValues !== initialValues) {
                form.reset(); // Reset the form when initialValues change
              }
            }
          }), submitting ? /*#__PURE__*/React.createElement("div", {
            className: "is_sending"
          }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
            className: "loading-spinner"
          }))) : null, /*#__PURE__*/React.createElement("div", {
            className: "form-row"
          }, /*#__PURE__*/React.createElement("label", null, _this2.props.translate('title'), "*"), /*#__PURE__*/React.createElement(Field, {
            name: "title",
            type: "text",
            component: _this2.renderInput,
            placeholder: _this2.props.translate('title')
          })), /*#__PURE__*/React.createElement("div", {
            className: "form-row"
          }, /*#__PURE__*/React.createElement("label", null, "ID*"), /*#__PURE__*/React.createElement(Field, {
            name: "courseCode",
            type: "text",
            component: _this2.renderInput,
            placeholder: _this2.props.translate('course-code'),
            validate: function validate(value, allValues, meta) {
              return asyncValidate(value, initialValues, meta);
            },
            maxLength: 50
          })), /*#__PURE__*/React.createElement("div", {
            className: "form-row"
          }, /*#__PURE__*/React.createElement("label", null, _this2.props.translate('Subject*')), /*#__PURE__*/React.createElement(Select, {
            isSearchable: true,
            isMulti: false,
            name: "subject",
            value: _this2.state.selectedSubject,
            onChange: function onChange(value) {
              return _this2.onSubjectChange(value);
            },
            className: "simple-select",
            defaultOptions: options,
            loadOptions: debounce(_this2.onSubjectSearch, 500, false),
            placeholder: _this2.props.translate('Search for a subject'),
            ignoreCase: true,
            loadingPlaceholder: _this2.props.translate('Loading...')
          })), initialValues != null && initialValues.id === 0 ? /*#__PURE__*/React.createElement("div", {
            className: "form-row",
            style: {
              padding: 0,
              margin: 0,
              marginTop: '1rem'
            }
          }, /*#__PURE__*/React.createElement(Expandable, {
            open: _this2.state.open,
            onChange: function onChange(open) {
              return _this2.setState({
                open: open
              });
            },
            title: _this2.props.translate('Subject description')
          }, /*#__PURE__*/React.createElement("label", {
            style: {
              marginTop: 0
            }
          }, _this2.props.translate('Subject title*')), /*#__PURE__*/React.createElement("input", {
            type: "text",
            onChange: function onChange(e) {
              return _this2.setState({
                subjectTitle: e.target.value
              });
            },
            value: _this2.state.subjectTitle || '',
            disabled: _this2.state.subjectId != 'new'
          }), /*#__PURE__*/React.createElement("label", null, _this2.props.translate('Area'), "*"), /*#__PURE__*/React.createElement("div", {
            className: "select"
          }, /*#__PURE__*/React.createElement("select", {
            name: "subjectSchoolType",
            value: _this2.state.subjectSchoolType,
            onChange: function onChange(e) {
              return _this2.setState({
                subjectSchoolType: e.target.value
              });
            },
            disabled: _this2.state.subjectId != 'new'
          }, _this2.schoolTypes.sort(function (a, b) {
            return translate(a).localeCompare(translate(b));
          }).map(function (type, index) {
            return /*#__PURE__*/React.createElement("option", {
              key: index,
              value: type
            }, _this2.props.translate(type));
          }))), /*#__PURE__*/React.createElement("label", null, _this2.props.translate('Subject code*')), /*#__PURE__*/React.createElement("input", {
            type: "text",
            onChange: function onChange(e) {
              return _this2.setState({
                subjectCode: e.target.value
              });
            },
            value: _this2.state.subjectCode,
            disabled: _this2.state.subjectId != 'new',
            maxLength: 50
          })), _this2.state.subjectError != null ? /*#__PURE__*/React.createElement("div", {
            style: {
              marginTop: '.35rem',
              color: 'red'
            }
          }, /*#__PURE__*/React.createElement("span", {
            style: {
              marginRight: '.35rem',
              position: 'relative',
              top: 2
            }
          }, /*#__PURE__*/React.createElement(Icon, {
            name: "Alert"
          })), _this2.state.subjectError) : null) : null, /*#__PURE__*/React.createElement("div", {
            className: "form-row"
          }, /*#__PURE__*/React.createElement("label", null, _this2.props.translate('Aim'), "*"), /*#__PURE__*/React.createElement(Field, {
            name: "purpose",
            component: Editor,
            value: purpose
          })), /*#__PURE__*/React.createElement("div", {
            className: "clearfix"
          }), /*#__PURE__*/React.createElement("div", {
            style: {
              marginTop: '4em'
            }
          }, _this2.renderCoreContent()), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Expandable, {
            title: _this2.props.translate('Learning objectives')
          }, /*#__PURE__*/React.createElement(MatrixForm, {
            matrix: _this2.state.matrix,
            type: ASSESSMENT_MATRIX,
            onMatrixFormUpdate: _this2.onMatrixFormUpdate,
            editView: _this2.props.editView
          }))), /*#__PURE__*/React.createElement("div", {
            className: "clearfix"
          }), /*#__PURE__*/React.createElement("div", {
            className: "form-divider"
          }), /*#__PURE__*/React.createElement("div", {
            className: "form-row spacing submit",
            style: {
              marginTop: '30px'
            }
          }, /*#__PURE__*/React.createElement(Button, {
            disabled: submitting || !valid || !subjectValid
          }, _this2.props.editView ? _this2.props.translate('save') : _this2.props.translate('publish')), /*#__PURE__*/React.createElement("div", {
            className: "align-right"
          }, /*#__PURE__*/React.createElement(Button, {
            onClick: function onClick(event) {
              event.preventDefault();

              _this2.props.onClose(false, false);
            },
            disabled: submitting,
            type: "secondary"
          }, _this2.props.translate('Cancel')))));
        }
      }));
    }
  }]);

  return CourseForm;
}(Component);

function mapStateToProps(state) {
  var initialValues = null;

  if (state.Courses.course != null) {
    initialValues = _objectSpread({}, state.Courses.course);
    initialValues.purpose = state.Courses.course.details[0].purpose;
  } else {
    var _state$user$tenant;

    var tenantId = (_state$user$tenant = state.user.tenant) === null || _state$user$tenant === void 0 ? void 0 : _state$user$tenant.tenantId;
    var predefinedCourseCodeOrder = 1;
    var prefix = tenantId.substring(0, tenantId.indexOf('-')) + "-";

    if (state.Courses.courses != null) {
      // Loop through existing courses to find the max predefinedCourseCodeOrder
      state.Courses.courses.forEach(function (course) {
        if (course.courseCode.startsWith(prefix)) {
          predefinedCourseCodeOrder = predefinedCourseCodeOrder + 1;
        }
      });
    } // Create new courseCode with incremented predefinedCourseCodeOrder


    var predefinedCourseCode = prefix + predefinedCourseCodeOrder;
    initialValues = {
      id: 0,
      courseCode: predefinedCourseCode
    };
  }

  return {
    initialValues: initialValues,
    courseByCourseCode: state.Courses.courseByCourseCode,
    translate: translate(state.Languages.translations),
    currentUser: state.user.currentUser,
    tenant: state.user.tenant,
    subjectsSearchResults: state.Subjects.search,
    tenantSubjects: state.Subjects.tenant,
    createdSubject: state.Subjects.created,
    group: state.sections.graphSection,
    customCourses: state.Courses.courses
  };
}

export default withRouter(connect(mapStateToProps, {
  getSectionByGraphId: getSectionByGraphId,
  addCourse: addCourse,
  updateCourse: updateCourse,
  getCourseByCourseCode: getCourseByCourseCode,
  getTenantSubjects: getTenantSubjects,
  searchSubjects: searchSubjects,
  createSubject: createSubject,
  getCourses: getCourses
})(CourseForm));